export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/USA-878dc817f7133f58f9c1a12c67f3ef19.mp3";